export const failureHash = {
    PAGECONFIG_COPY_FORBIDDEN: "API__EP__PAGE_CONFIG__PAGECONFIG_COPY_FORBIDDEN",
    PAGE_CONFIG_NAME_ALREADY_EXISTS: "API__EP__PAGE_CONFIG__PAGE_CONFIG_NAME_ALREADY_EXISTS",
    UNKNOWN: "API__EP__PAGE_CONFIG__UNKNOWN",
};
//# sourceMappingURL=pageconfig_old.static.js.map